<template>
  <div>
    <Accordion
      :is-open="false"
      :disabled="accordionDisabled"
    >
      <template #head>
        さらに絞り込む
      </template>
      <template #body>
        <div class="boss-table-2">
          <scout-form-gender
            v-if="showGender"
            v-model="filterData.gender"
          />
          <scout-form-prefecture
            v-if="showPrefecture"
            :prefectures.sync="filterData.address.prefectures"
            :cities.sync="filterData.address.cities"
            label="現住所"
          />
          <scout-form-educational-background
            v-if="showEducationalBackground"
            v-model="filterData.educationalBackground"
          />
          <scout-form-employed
            v-if="showEmployed"
            v-model="filterData.employed"
          />
          <scout-form-others
            v-if="showOthers"
            v-bind.sync="filterData"
          />
          <scout-form-member-id v-model.number="filterData.userId" />
          <scout-form-pull-down
            v-if="!isRecommended && !isSearch"
            v-model="filterData.searchConditionName"
            :options="searchConditionNames"
            data-test="search-name"
            label="検索条件名"
          />
        </div>
      </template>
    </Accordion>
  </div>
</template>

<script>
import { mapActions, mapGetters } from 'vuex'
import _ from 'lodash'
import * as definition from '@/lib/labelValueMappings'
import scoutMemberFilterUtil from '@/lib/scoutMemberFilterUtil'
import Accordion from '@/components/atoms/Accordion'
import ScoutFormEmployed from '@/components/atoms/ScoutFormEmployed'
import ScoutFormGender from '@/components/atoms/ScoutFormGender'
import ScoutFormMemberId from '@/components/atoms/ScoutFormMemberId'
import ScoutFormPrefecture from '@/components/atoms/ScoutFormPrefecture'
import ScoutFormPullDown from '@/components/atoms/ScoutFormPullDown'
import ScoutFormEducationalBackground from '@/components/atoms/ScoutFormEducationalBackground'
import ScoutFormOthers from '@/components/atoms/ScoutFormOthers'

const defaultSearchParameter = {
  gender: null,
  educationalBackground: null,
  employed: null,
  hasCareerResumes: false,
  address: { selectedOption: null },
  userId: null
}

export default {
  components: {
    Accordion,
    ScoutFormEmployed,
    ScoutFormGender,
    ScoutFormMemberId,
    ScoutFormPrefecture,
    ScoutFormPullDown,
    ScoutFormEducationalBackground,
    ScoutFormOthers
  },
  mixins: [scoutMemberFilterUtil],
  props: {
    memberObjects: {
      type: Array,
      default: () => ([])
    },
    isCandidate: {
      type: Boolean,
      default: false
    },
    isSearch: {
      type: Boolean,
      default: false
    },
    isRecommended: {
      type: Boolean,
      default: false
    },
    jobId: {
      type: Number,
      default: null
    }
  },
  data () {
    return {
      employedOptions: definition.employed,
      searchParameter: _.cloneDeep(defaultSearchParameter)
    }
  },
  computed: {
    ...mapGetters({
      searchDataByJobId: 'membersSearchCondition'
    }),
    searchDataParameter () {
      return this.searchDataByJobId(this.jobId).parameter
    },
    showGender () {
      return this.searchParameter.gender === null
    },
    showPrefecture () {
      return this.renderModal && this.searchParameter.address.selectedOption !== 'present_address'
    },
    showEducationalBackground () {
      return this.searchParameter.educationalBackground === null
    },
    showEmployed () {
      return this.searchParameter.employed === null
    },
    showOthers () {
      return !this.isSearch || !this.searchParameter.hasCareerResumes
    },
    accordionDisabled () {
      return !!this.searchParameter.userId
    }
  },
  watch: {
    searchDataParameter: {
      handler () {
        this.fetchSearchParameter()
      }
    }
  },
  created () {
    const masters = [
      'genders',
      'educationalBackgrounds',
      'prefectures'
    ]
    masters.forEach(element => {
      this.storeMaster(element)
    })
    this.$set(this.filterData, 'excludesDisabledScout', (this.isCandidate) ? false : undefined)
    this.fetchSearchParameter()
  },
  methods: {
    ...mapActions({
      storeMaster: 'storeMaster'
    }),
    isDisabled (val) {
      return !!val
    },
    fetchSearchParameter () {
      if (!this.isSearch) {
        // 会員検索結果画面以外の場合はデフォルト値を使用
        this.$set(this, 'searchParameter', _.cloneDeep(defaultSearchParameter))
        return
      }
      // 会員検索結果画面の場合は検索条件を取得
      this.$set(this.searchParameter, 'gender', this.searchDataParameter.gender)
      this.$set(this.searchParameter, 'educationalBackground', this.searchDataParameter.educationalBackground)
      this.$set(this.searchParameter, 'employed', this.searchDataParameter.employed)
      this.$set(this.searchParameter.address, 'selectedOption', this.searchDataParameter.address.selectedOption)
      this.$set(this.searchParameter, 'hasCareerResumes', this.searchDataParameter.hasCareerResumes)
      this.$set(this.searchParameter, 'userId', this.searchDataParameter.userId)
    }
  }
}
</script>
